module.exports = __webpack_public_path__ + "img/9791185823348.469714d9.jpg";